import React, { Component } from 'react'
import { connect } from 'react-redux'
import JqxTabs from '../widgets/jqwidgets-react/react_jqxtabs';
import UserGridContainer from '../components/grids/UserGridContainer';
import GroupGridContainer from '../components/grids/GroupGridContainer';
import AccessGridContainer from '../components/grids/AccessGridContainer';
import Notifications from '../components/notifictions/Notifications';
import * as actions from '../actions';
class AdminPanel extends Component {

    componentDidMount(){
        this.refs.tabs.on('selected', (event) =>
        {
            let selectedTab = event.args.item;
            console.log(selectedTab);
            if(selectedTab === 1){
                this.refs.groupGrid.refs.grid.refs.grid.updatebounddata()
            } else if(selectedTab === 2){
                this.refs.accessGrid.refs.grid.refs.grid.updatebounddata()
            }
        });

    }

  render() {
      //for test
      let onlineStatuses = [
          {login: '79940073350', onlineStatus: true},
          {login: '79940073350', onlineStatus: true},
          {login: '79940073350', onlineStatus: false},
          {login: '79940073350', onlineStatus: false},
          {login: '79940073350', onlineStatus: false},
          {login: '79940073350', onlineStatus: true},
          {login: '79940073350', onlineStatus: true},
          {login: '79940073350', onlineStatus: false}
          ];
    return (
      <div style={{width: '100%', position: 'absolute', height: '100%', overflow: 'hidden'}}>
              <JqxTabs ref="tabs">
                <ul>
                  <li style={{marginLeft: 30}}>Пользователи</li>
                  <li>Группы</li>
                  <li>Доступ</li>
                  {/*<li>Уведомления</li>*/}
                </ul>
                <UserGridContainer
                    ref={'userGrid'}
                    users={this.props.users}
                    groupNameList={this.props.groupNameList}
                    userTypeList={this.props.userTypeList}
                    typeMap={this.props.typeMap}
                    checkedGroupAccess={this.props.checkedGroupAccess}
                    onAddGroupAccess={this.props.onAddGroupAccess}
                    onRemoveGroupAccess={this.props.onRemoveGroupAccess}
                    onClearGroupAccess={this.props.onClearGroupAccess}
                    changeUserName={this.props.changeUserName}
                    removeUser={this.props.removeUser}
                    addUser={this.props.addUser}
                    setError={this.props.setError}
                    clearError={this.props.clearError}
                    filterUsers={this.props.filterUsers}
                    showLoader={this.props.showLoader}
                    hideLoader={this.props.hideLoader}/>
                <GroupGridContainer
                    ref={'groupGrid'}
                    groups={this.props.groups}
                    groupNameList={this.props.groupNameList}
                    users={this.props.users}
                    updateGroup={this.props.updateGroup}
                    clearError={this.props.clearError}
                    filterUsers={this.props.filterUsers}
                    showLoader={this.props.showLoader}
                    hideLoader={this.props.hideLoader}/>
                <AccessGridContainer
                    ref={'accessGrid'}
                    access={this.props.access}
                    users={this.props.users}
                    groups={this.props.groups}
                    filterUsers={this.props.filterUsers}
                    setError={this.props.setError}
                    clearError={this.props.clearError}
                    showLoader={this.props.showLoader}
                    hideLoader={this.props.hideLoader}/>
                {/*<Notifications*/}
                    {/*onToggleReceiver={this.props.onToggleReceiver}*/}
                    {/*onlineStatuses={onlineStatuses}*/}
                    {/*users={this.props.users}*/}
                    {/*selectedReceivers={this.props.selectedReceivers}/>*/}
              </JqxTabs>
          <button
              style={{position: 'absolute', top: 5, right: 15, color: '#2170ef'}}
                onClick={() => {
                    window.localStorage.removeItem('token');
                    window.location.href = window.location.href;
                }}>Выйти</button>
      </div>);
  }
}


function mapStateToProps(state) {
    return {
        currentTab: state.adminPanelReducer.currentTab,
        users: state.adminPanelReducer.users,
        groups: state.adminPanelReducer.groups,
        access: state.adminPanelReducer.access,
        userTypeList: state.adminPanelReducer.userTypeList,
        groupNameList: state.adminPanelReducer.groupNameList,
        selectedReceivers: state.NotificationsReducer.selectedReceivers,
        typeMap: state.adminPanelReducer.typeMap,
        checkedGroupAccess: state.adminPanelReducer.checkedGroupAccess,
        filterUsers: state.adminPanelReducer.filterUsers
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onToggleReceiver: (receiver, checked) => {
            dispatch(actions.toggleReceiver(receiver, checked))
        },
        onAddGroupAccess: (groupAccess) => {
            dispatch(actions.addGroupAccess(groupAccess))
        },
        onRemoveGroupAccess: (groupAccess) => {
            dispatch(actions.removeGroupAccess(groupAccess))
        },
        onClearGroupAccess: () => {
            dispatch(actions.clearGroupAccess())
        },
        updateGroup: (login, groupName) => {
            dispatch(actions.updateGroup(login, groupName))
        },
        changeUserName: (login, userName, type) => {
            dispatch(actions.changeUserName(login, userName, type))
        },
        removeUser: (login, type) => {
            dispatch(actions.removeUser(login, type))
        },
        addUser: (login, userName, type) => {
            dispatch(actions.addUser(login, userName, type));
        },
        setError: (error) => {
            dispatch(actions.setError(error));
        },
        clearError: () => {
            dispatch(actions.clearError());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminPanel);



// WEBPACK FOOTER //
// ./src/containers/AdminPanel.js